// Vueで使用するHTTPクライアントモジュールの読み込み
import axios from 'axios';
import vueConfig from './vue.config.js';
// Vue JS本体モジュールの読み込み
import Vue from 'vue';
import {Intersect} from 'vuetify/lib/directives'
// Setup VeeValidate
import {setupVeeValidate} from './plugin/veeValidate.js'
// vuetify
import vuetify, {setUserPresetLightThemes} from './plugin/vuetify'
// 買取トップ
import BuyTop from "./components/pages/static/buy-top.vue";
// 買取LP申込完了
import QuickEntryComplete from "./components/organisms/buy/quick-entry-complete.vue";
import QuickEntryVbComplete
    from "./components/pages/buy/quick-entry-vb-complete.vue";
import Vuex from 'vuex';
import VueRouter from 'vue-router';
import store from './store/memberBuyStore'
import router from "./routes/sellRouter";

window.axios = axios;

window.VueConfig = vueConfig;

Vue.directive('intersect', Intersect)

setupVeeValidate(Vue)

const customLightThemeOptions = {
    primaryTextColor: '#1F3134',
    secondary: '#0095d9',
    accent: '#58a0c1',
    accent2: '#F7F5EB',
    accent3: '#00475A',
}

// テーマを設定する前にsetUserPresetLightThemesを呼び出す
setUserPresetLightThemes(customLightThemeOptions)


Vue.prototype.$filters = {
    addCommaSeparator(value) {
        return value.toLocaleString();
    }
}
/**
 * カスタムディレクティブ
 */
// v-showではdisplay:noneしかできないため、visibility: hiddenを使えるようにする
// v-visible=(条件)で使用する
Vue.directive('visible', function (el, binding) {
    el.style.visibility = !!binding.value ? 'visible' : 'hidden';
});

Vue.use(Vuex);
Vue.use(VueRouter);

// 判定識別子
Vue.prototype.$siteCode = VueConfig.siteCode.valuebooks;


// 指定要素で起動するためにVueインスタンスを実行
const vm = new Vue({
    el: '#app_sell_offer',
    store,
    vuetify,
    router,
    components: {
        BuyTop,
        QuickEntryComplete,
        QuickEntryVbComplete
    }
});

/**
 * フィルター定義
 */
// 金額をカンマ区切りにする
Vue.filter('addCommaSeparator', function (value) {
    return value == null || isNaN(value) ? '' : value.toLocaleString();
});
